// @flow
import type { AddOn, JournalEntry, LedgerAccount } from './types';
import { compareAllDataEntries } from './comparators';

const compileIssuesViewData = (
  addOns: Array<AddOn>,
  categorizationInconsistencies: Array<Object>,
  dataEntries: Array<Object>,
  journalEntries: Array<JournalEntry>,
  ledgerAccounts: Array<LedgerAccount>,
) => {
  const inconsistentDataEntryIdSet = categorizationInconsistencies.reduce(
    (allInconsistentDataEntryIds, { dataEntryIds }) => {
      // Each categorization inconsistency has a list of data entry IDs that should be marked as
      // being inconsistently categorized, so put them all in one set to check against
      dataEntryIds.forEach(id => allInconsistentDataEntryIds.add(id));
      return allInconsistentDataEntryIds;
    },
    new Set(),
  );

  const addOnsMap: Map<string, AddOn> = new Map();
  addOns.forEach(addOn => addOnsMap.set(addOn.id, addOn));
  const ledgerAccountMap: Map<string, LedgerAccount> = new Map();

  ledgerAccounts.forEach(ledgerAccount => ledgerAccountMap.set(ledgerAccount.id, ledgerAccount));
  const journalEntriesMap: Map<string, JournalEntry> = new Map();
  journalEntries.forEach(originalJournalEntry => {
    const addOn = originalJournalEntry.addOn
      ? addOnsMap.get(originalJournalEntry.addOn.id)
      : undefined;
    const journalEntry = {
      ...originalJournalEntry,
      addOn,
    };

    journalEntriesMap.set(originalJournalEntry.id, journalEntry);
  });
  const dataEntriesWithInconsistencies = [];
  dataEntries.forEach(originalDataEntry => {
    const journalEntry = journalEntriesMap.get(originalDataEntry.journalEntry.id);
    const ledgerAccount = ledgerAccountMap.get(originalDataEntry.ledgerAccount.id);
    const hasPotentialQualityIssues = inconsistentDataEntryIdSet.has(originalDataEntry.id);
    const dataEntry = {
      ...originalDataEntry,
      journalEntry,
      hasPotentialQualityIssues,
      ledgerAccount,
    };
    if (hasPotentialQualityIssues) {
      dataEntriesWithInconsistencies.push(dataEntry);
    }
  });

  dataEntriesWithInconsistencies.sort(compareAllDataEntries);

  return {
    dataEntriesWithInconsistencies,
  };
};

export default compileIssuesViewData;
